import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';

const PPT_ID = '26500';
const PAGEVIEW_GID = '68767';

export default function trackWeatherRegistration(): void {
  try {
    const osanoCookie = Cookies.get('at_osano');
    if (osanoCookie) {
      const osanoData = JSON.parse(decodeURIComponent(osanoCookie));
      if (osanoData?.consent?.MARKETING === 'ACCEPT') {
        const url = `https://trkn.us/pixel/conv?ppt=${PPT_ID}&ord=${uuidv4()}&g=registration&gid=${PAGEVIEW_GID}`;
        fetch(url, { keepalive: true, mode: 'no-cors', credentials: 'omit' });
      }
    }
  } catch {
    // Cookie missing or unparseable
  }
}
